var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"path":"clicks","auth-api":_vm.api}},[(_vm.showClientSuspendedBanner)?_c('ClientSuspendedBanner',{staticClass:"default-layout-banner"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.suspendedBannerMsg)}})]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }